import React from 'react';

export const CONTACT_US_ICON_PATHS: Record<string, string> = {
    chat: '/icons/contact-chat.svg',
    whatsapp: '/icons/contact-whatsapp.svg',
    form: '/icons/contact-form.svg',
    help: '/icons/contact-help.svg',
};

interface ContactUsIconProps {
    iconKey: string;
    size?: number;
    className?: string;
}

export const ContactUsIcon: React.FC<ContactUsIconProps> = ({ iconKey, size = 22, className }) => {
    const src = CONTACT_US_ICON_PATHS[iconKey];
    if (!src) return null;
    return <img src={src} alt="" aria-hidden="true" width={size} height={size} className={className} />;
};
